<template>
    <div class="filter-item filter-item--checkbox filter-item--checklist filter-item--checklist--padding">
        <h2 class="filter-item__heading" v-text="title"></h2>
        <div class="filter-item__checklist ">
            <div class="filter-item__flex">
                <button class="filter-btn" @click="checkAll" v-text="translations.all"></button>
                <button class="filter-btn" @click="clearAll" v-text="translations.none"></button>
            </div>
            <p class="filter-item__notice" v-if="chooseOne" v-text="translations.choose_one"></p>
            <checkbox v-for="(option, optionKey) in staredList" :name="option.name" :value="option.checked" @checked="(checked) => setChecked(checked, optionKey)" :key="option.code"></checkbox>
        </div>
         <button class="btn-expand" @click="showNonStarred = !showNonStarred" :class="{'show-all': showNonStarred}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 395.65"><path d="M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"/></svg>
        </button>
    </div>
</template>

<script>
import Checkbox from '../checkbox.vue'
import _ from 'underscore';
import { trackEvent } from '../../tracker';

export default {
    props: {
        title: {type: String, default: ''},
        options: {type: Array, default() {return [ ]}},
        filterName: {type: String, default: ''}
    },
    data() {
        return {
            checkAllIfEmpty: true,
            translations: APP_CONFIG.TRANSLATION.CHECKBOX_LIST_FILTER,
            showNonStarred: false
        }
    },
    methods: {
        checkAll() {
            this.clearAll();
            this.checkAllIfEmpty = true;
        },
        clearAll() {
            this.checkAllIfEmpty = false;
            let query = Object.assign({}, this.$route.query);
            if(query[this.filterName]) {
                delete query[this.filterName];
            }

           this.$router.replace({query}, (to, from, next) => {
                trackEvent({
                    event: 'Filter - ' + this.title,
                    target: to.fullPath,
                    value: [ ],
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction',
                })
            });
        },
        setChecked(checked, optionKey) {
            let list = this.list.map((item) => Object.assign({}, item));
            if(!list[optionKey]) {
                return;
            }

            list[optionKey].checked = checked;
            let checkedItems = list.filter((item) => item.checked);
            let query = Object.assign({}, this.$route.query);
            if(checkedItems.length != this.options.length) {
                query[this.filterName] = JSON.stringify(_.flatten(checkedItems.map((item) => item.codes)));
            } else if(query[this.filterName]) {
                delete query[this.filterName];
            }

            this.$router.replace({query}, (to, from, next) => {
                trackEvent({
                    event: 'Filter - ' + this.title,
                    target: to.fullPath,
                    value: checkedItems,
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction',
                })
            });
        }
    },
    computed: {
        value() {
            return this.$route.query[this.filterName] || '';
        },
        checkedList() {
            if(!this.value) {
                return null;
            }

            try {
                if(typeof this.value === 'string') {
                    let list = JSON.parse(this.value);
                    return list;
                } else if(typeof this.value === 'object') {
                    return this.value;
                }
            } catch(e) {
                console.error(e);
                return null;
            }
        },
        chooseOne() {
            return !this.checkedList && !this.checkAllIfEmpty;
        },
        list() {
            let checkedList = this.checkedList;
            return this.options.map((item) => {
                item = Object.assign({}, item);
                if(checkedList && checkedList.length > 0) {
                    let check = item.codes.filter((code) => {
                        return checkedList.indexOf(code) > -1;
                    });
                    item.checked = (check.length > 0) ? true : false;
                } else if(this.checkAllIfEmpty) {
                    item.checked = true;
                } else {
                    item.checked = false;
                }
                
                return item;
            });
        },
        staredList() {
            return (this.showNonStarred) ? this.list : this.list.slice(0, 4);
        }
    },
    components: {
        Checkbox
    }
}
</script>
